<template>
  <div class="messMemory">
    <h4 class="tit">
      <div v-for="(item, index) in memoryTit" :key="index" :class="activeClass == index ? 'titactive':''"
        @click="switchover(index)" style="cursor: pointer;">{{item}}</div>
    </h4>
    <!-- <div class="memoryList"> -->
    <ul class="memoryList">
      <li class="memoryBank_" v-for="(item, index) in memoryTermBank" :key="index" ref="memoryBank">{{item.name}}</li>
      <li class="empty" v-if="memoryTermBank.length ? false : true">您上传过的{{name}}会出现在这里~</li>
    </ul>
    <!-- </div> -->
    <h5>上传{{name}}</h5>
    <div class="memoryUpload">
      <el-upload class="upload-demo" action :http-request="uploadSectionFile" multiple drag :limit="20"
        :on-exceed="handleExceed" :file-list="fileArr" :before-upload="beforeUploadFile"
        :on-progress="uploadFileProcess" :on-success="handleFileSuccess" :on-change="uploadChange"
        :show-file-list="false" accept=".xls,.xlsx,.txt,.tmx,.tbx">
        <div class="uploadBox" v-if="fileArr.length ? false : true">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">上传{{templateName}}、xlsx、txt文件,且单个文件50M以下</div>
        </div>
        <template>
          <el-table v-if="fileArr.length ? true : false" class="tabBox" :data="fileArr" style="width: 100%"
            height="100%">
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column prop="name" label="名称" min-width="10" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column label="上传状态" min-width="10">
              <template slot-scope="scope">
                <img :src="scope.row.percentage===100 ? succeedImgSrc : imgSrc" alt />
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="10">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                  <i class="icon-delete" @click.stop="handleDelete(scope.$index, scope.row)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-upload>
    </div>
    <p class="mesTemplate">
      *点击图标下载模板
      <!-- <img style="cursor:pointer;" src="../assets/imgs/memory/normal_tmx.png" alt />
      <img style="cursor:pointer;" src="../assets/imgs/memory/normal_txt.png" alt />-->
      <!-- <img style="cursor:pointer;" src="../assets/imgs/memory/normal_xlsx.png" alt />  -->
      <!-- <i class="tbx" v-show="activeClass"></i>
      <i class="tmx" v-show="!activeClass"></i>
      <i class="txt"></i>
      <i class="xlsx"></i>-->
      <a :href="this.baseURL+'/api/v1/memory/exportMemoryTemp?type=tmx'" v-show="!activeClass">
        <i class="tmx">
          <!-- <span>tmx</span> -->
        </i>
      </a>
      <a :href="this.baseURL+'/api/v1/term/exportTermTemp?type=tbx'" v-show="activeClass">
        <i class="tbx">
          <!-- <span>tbx</span> -->
        </i>
      </a>
      <a :href="this.baseURL+templateUrl+'?type=txt'">
        <i class="txt">
          <!-- <span>txt</span> -->
        </i>
      </a>
      <a :href="this.baseURL+templateUrl+'?type=xlsx'">
        <i class="xlsx">
          <!-- <span>xlsx</span> -->
        </i>
      </a>
    </p>
  </div>
</template>

<script>

import axios from "axios";
export default {
  name: "messMemory",
  props: ["isCall", "projectId"],
  data() {
    return {
      memoryTit: ["项目记忆库", "项目术语库"],
      fileArr: [],
      termArr: [],
      memoryArr: [],
      memoryTermBank: [],
      memoryBank: [],
      termBank: [],
      activeClass: 0,
      qq: [],
      obp: true,
      imgSrc: require("../assets/imgs/memory/upload_failure.png"),
      succeedImgSrc: require("../assets/imgs/memory/upload_success.png"),
      memoryUrl: [],
      termUrl: [],
      templateUrl: "/api/v1/memory/exportMemoryTemp",
      fileUrl: "/api/v1/memory/checkFileContent",
      name: "记忆库",
      templateName: "tmx"
    };
  },
  components: {},
  watch: {
    // 清空
    isCall() {
      this.callFileArr();
    },
    // 下载路径
    activeClass() {
      if (this.activeClass) {
        this.templateUrl = "/api/v1/term/exportTermTemp";
        this.fileUrl = "/api/v1/term/checkFileContent";
        this.name = "术语库";
        this.templateName = "tbx";
      } else {
        this.templateUrl = "/api/v1/memory/exportMemoryTemp";
        this.fileUrl = "/api/v1/memory/checkFileContent";
        this.name = "记忆库";
        this.templateName = "tmx";
      }
    }
  },
  created() {
    this.getList();
  },
  methods: {
    callFileArr() {
      this.fileArr = [];
      this.termArr = [];
      this.memoryArr = [];
    },
    getList() {
      var that = this;
      var params = { id: this.projectId };
      this.catReq1Service("/api/v1/project/queryProjectTermMemoryList", params)
        .then(function (response) {
          if (!response.success) {
            return;
          }
          var data = response.result;
          that.memoryTermBank = data.transMemoryLibList;
          that.termBank = data.transTermLibList;
          that.memoryBank = data.transMemoryLibList;
        });
    },
    switchover(index) {
      this.activeClass = index;
      // // debugger
      if (index === 1) {
        this.memoryTermBank = this.termBank;
        this.fileArr = this.termArr;
      } else {
        this.memoryTermBank = this.memoryBank;
        this.fileArr = this.memoryArr;
      }
    },
    // 检测文件编码
    getFileContent(path, param) {
      var that = this;
      this.catReq1Service(this.fileUrl, {
        fileUrlList: [path]
      })
        .then(function (response) {
          if (!response.success) {
            return;
          }

          var data = response.result;
          if (data.status === 0) {
            that.$message.closeAll();
            that.$message({
              message: data.reason,
              type: "warning"
            });
          }
          that.fileArr.forEach(item => {
            if (item.uid === param.file.uid) {
              // console.log(item, "statusstatus");
              if (data.status === 0) {
                item.percentage = -1;
                if (that.activeClass == 1) {
                  that.termUrl.remove(path)
                  // that.termUrl.pop();
                  // that.termArr.pop();
                } else {
                  that.memoryUrl.remove(path)
                  // that.memoryArr.pop();
                }
              }
            }
          });
          // that.refresh++;
          // that.$store.commit("setFileList", that.fileArr);
          // that.fileArr = ary;
          // console.log(that.fileArr);
        });
    },
    // 上传的第二个函数
    getFileHost(param) {
      var that = this;
      // alert(that.host)
      var FileController = that.host;
      var config = {
        onUploadProgress: progressEvent => {
          const complete =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
          param.onProgress({ percent: complete });
        }
      };
      axios.post(FileController, that.formData, config)
        .then(function (response) {
          if (!response) {
            return;
          }
          // console.log(response.data.result);
          that.getFileContent(response.data.result.fileName, param);
          if (that.activeClass == 1) {
            that.termUrl.push(response.data.result.fileName);
          } else {
            that.memoryUrl.push(response.data.result.fileName);
          }
          var obj = {
            memoryArr: that.memoryArr,
            termArr: that.termArr,
            memoryUrl: that.memoryUrl,
            termUrl: that.termUrl
          };
          // console.log(obj, "obj");
          that.$emit("getMessForm", obj);
        });
    },
    // 上传函数——获取签名
    uploadSectionFile(param) {
      if (!param.file.obp) {
        // this.obp = true;
        return;
      }
      // console.log(param, "/////////????////");
      var that = this;
      var fileObj = param.file;
      var re = /([^\.\/\\]+)\.([a-z]+)$/i, // 匹配拿到后缀
        resultArr = re.exec(param.file.name);
      var type = resultArr[2];
      var code = localStorage.getItem("myCompanyCode");
      //自定义文件上传
      // // console.log(param);
      var url = "/api/v1/file/getUploadSign";
      var params = { companyCode: code, fileType: "catlib" };
      this.catReq1Service(url, params).then(function (response) {
        if (!response.success) {
          return;
        }
        var data = response.result;
        that.host = data.host;
        var key = data.keyPrefix + "." + type;
        delete data.keyPrefix;
        delete data.host;
        that.formData = new FormData();
        that.formData.append("key", key);
        Object.keys(data).forEach(function (key) {
          // console.log(key, data[key]);
          that.formData.append(key, data[key]);
        });
        that.formData.append("file", fileObj);
        that.getFileHost(param);
      });
    },
    uploadChange(event, file, fileList) {
      this.fileArr = file;
    },
    /// 超出文件限制提示
    handleExceed() {
      this.$message({
        message: "最多20个文件",
        type: "warning"
      });
    },
    //上传前的函数(用于验证上传文件格式及大小)
    beforeUploadFile(file) {
      var that = this;
      let type = this.typeReg(file.name) // 拿到文件后缀
      // that.fileArr.forEach(item => {
      //   if (item.name == file.name) {
      //     // that.fileArr.pop();
      //     that.$message({
      //       message: "上传文件名称重复!",
      //       type: "warning"
      //     });
      //     this.obp = false;
      //   }
      // });
      file.obp = true;
      this.fileArr.slice(0, -1).forEach(item => {
        if (item.name == file.name) {
          this.fileArr.pop();
          this.$message({
            message: "上传文件名称重复!",
            type: "warning"
          });
          file.obp = false;
          return false;
        }
      });
      const isTMX = type === that.templateName;
      const isTXT = type === "txt";
      const isXLSX = type === "xlsx";
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isTXT && !isXLSX && !isTMX) {
        that.$message.closeAll();
        that.$message({
          message: `只支持${that.templateName}/xlsx/txt格式上传哦!`,
          type: "warning"
        });
        file.obp = false;
      }
      if (file.size < 1) {
        this.$message.closeAll();
        this.$message({
          message: "不支持上传空文件",
          type: "warning"
        });
        return false;
      }
      if (!isLt50M) {
        this.$message.closeAll();
        that.$message({
          message: "上传文件大小不能超过 50MB!",
          type: "warning"
        });
        file.obp = false;
      }
      return (isTXT || isXLSX || isTMX) && isLt50M;
    },
    //文件上传成功的函数(用于文件上传成功之后的逻辑)
    handleFileSuccess(res, file, fileList) {
      // console.log(this.ifForm, "submit!");
      var that = this;
      // // console.log(fileList, "333333");
      // // console.log(file);
      // // console.log(res);
      that.fileArr = fileList;
      // console.log(that.fileArr);
      var obj = {
        memoryArr: that.memoryArr,
        termArr: that.termArr,
        memoryUrl: that.memoryUrl,
        termUrl: that.termUrl
      };
      // console.log(obj, "obj");
      that.$emit("getMessForm", obj);
      // that.fileArr.forEach((item, index) => {
      //   // item.progressFlag = false;
      //   if (item.status == "success") {
      //     item.successFlag = true;
      //   } else {
      //     item.successFlag = false;
      //   }
      // });
    },
    //文件上传过程中的函数(在这里获取进度条的进度)
    uploadFileProcess(event, file, fileList) {
      var that = this;
      //  if (event.percent==100) {
      //   this.fileArr.push(file)
      // }
      // debugger
      if (this.activeClass == "1") {
        // 术语库
        that.termArr = fileList;
      } else {
        // 记忆库
        that.memoryArr = fileList;
      }
      // that.fileArr.forEach(item => {
      //   if (item.percentage == 100) {
      //   } else {
      //     // item.progressFlag = true;
      //     // console.log(item.percentage);
      //     item.progressPercent = Math.abs(item.percentage.toFixed(0));
      //     // console.log(item.progressPercent);
      //   }
      // });
    },

    // 删除文件
    handleDelete(index, rows) {
      var that = this;
      that.fileArr.splice(index, 1);
      if (that.activeClass == 1) {
        that.termUrl.splice(index, 1);
        that.termArr.splice(index, 1);
      } else {
        that.memoryUrl.splice(index, 1);
        that.memoryArr.splice(index, 1);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.messMemory {
  position: relative;
  h5 {
    margin: 10px auto;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
  }
  .tit {
    position: absolute;
    left: 50px;
    top: -50px;
    .titactive {
      border-bottom: 2px rgba(69, 69, 69, 1) solid;
      color: rgba(69, 69, 69, 1);
    }
    div {
      float: left;
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: rgba(69, 69, 69, 1);
    }
    div:nth-child(2) {
      margin-left: 30px;
    }
  }
  .memoryList {
    width: 39.5vw;
    height: 8.1vw;
    background: rgba(241, 241, 241, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    padding: 10px;
    overflow: auto;
    margin: 0 auto;
    margin-top: 59px;
    box-sizing: border-box;
    .empty {
      font-size: 12px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(128, 128, 128, 1);
      border: 0px;
      text-align: left;
    }
    // .active span {
    //   background: rgba(80, 188, 255, 1) !important;
    //   color: rgba(255, 255, 255, 1) !important;
    // }
    // .active2 span {
    //   background: rgba(80, 188, 255, 1) !important;
    //   color: rgba(255, 255, 255, 1) !important;
    // }
    .memoryBank_ {
      float: left;
      height: calc(100% - 61px);
      overflow-y: auto;
      margin-left: 11px;
      margin-bottom: 10px;
      // margin-top: 10px;
      cursor: pointer;
      background: rgba(133, 133, 133, 1);
      border-radius: 2px;
      padding: 0 5px;
      display: inline-block;
      height: 26px;
      line-height: 26px;
      font-size: 14px;
      max-width: 400px;
      word-break: keep-all; /* 不换行 */
      white-space: nowrap; /* 不换行 */
      overflow: hidden;
      text-overflow: ellipsis;
      color: rgba(255, 255, 255, 1);
    }
    // .memoryBank_:hover span {
    //   // background: rgba(80, 188, 255, 1);
    //   // color: rgba(255, 255, 255, 1);
    // }
  }

  .memoryUpload {
    width: 39.5vw;
    height: 9vw;
    background: rgba(241, 241, 241, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    /deep/.el-table__row td {
      border-left: 1px transparent !important;
    }
    /deep/.el-table td {
      border-bottom: 0px solid #ffff;
      text-align: center;
    }
    /deep/.el-table td,
    .el-table th {
      // 修改table行高
      padding: 0px !important;
      height: 32px;
      font-size: 12px;
    }
    /deep/.el-table tr th {
      text-align: center;
    }
    /deep/.el-table tr th:nth-child(2) {
      text-align: left;
    }
    /deep/.el-table tr td:nth-child(2) {
      text-align: left;
    }
    /deep/.el-table tr td:nth-child(3) {
      text-align: center;
    }
    .el-table {
      background: rgba(241, 241, 241, 1);
      .icon-delete {
        display: inline-block;
        width: 20px;
        height: 18px;
        background: url("../assets/imgs/memory/delete_normal.png") no-repeat;
        vertical-align: middle;
      }
      // .icon-delete:hover {
      //   background: url("../assets/imgs/memory/delete_hover.png") no-repeat;
      // }
      .icon-delete:active {
        background: url("../assets/imgs/memory/delete_press.png") no-repeat;
      }
    }
    /deep/.el-table th {
      background: rgba(241, 241, 241, 1);
    }
    /deep/.el-table tr {
      background: rgba(241, 241, 241, 1);
    }
    /deep/.upload-demo {
      width: 37.5vw;
      height: 9vw;
    }
    /deep/.el-upload-dragger {
      width: 37.5vw;
      height: 9vw;
      background: rgba(241, 241, 241, 1);
      display: flex;
      justify-content: center;
      align-items: center;
      border: 0px;
      // border-radius: 2px;
    }
  }
  .mesTemplate {
    margin: 0 auto;
    margin-top: 10px;
    width: 720px;
    text-align: left;
    font-size: 12px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    i {
      margin-left: 10px;
      width: 20px;
      height: 26px;
      display:block;
      cursor: pointer;
      margin: 0 auto;
    }
    .tmx {
      background: url("../assets/imgs/memory/tmx.png");
    }
    .txt {
      background: url("../assets/imgs/memory/txt.png");
    }
    .xlsx {
      background: url("../assets/imgs/memory/xlsx.png");
    }
    .tbx {
      background: url("../assets/imgs/memory/tbx.png");
    }
    // .tmx:hover {
    //   background: url("../assets/imgs/memory/hover_tmx.png");
    // }
    // .txt:hover {
    //   background: url("../assets/imgs/memory/hover_txt.png");
    // }
    // .xlsx:hover {
    //   background: url("../assets/imgs/memory/hover_xlsx.png");
    // }
    // //  .tbx:hover {
    // //   background: url("../assets/imgs/memory/tbx_hover.png");
    // // }
    // .tbx:active {
    //   background: url("../assets/imgs/memory/tbx_press.png");
    // }
    // .tmx:active {
    //   background: url("../assets/imgs/memory/press_tmx.png");
    // }
    // .txt:active {
    //   background: url("../assets/imgs/memory/press_txt.png");
    // }
    // .xlsx:active {
    //   background: url("../assets/imgs/memory/press_xlsx.png");
    // }
  }
}
</style>